import { BreadcrumbVuexStore } from '@made-people/nuxt-breadcrumbs'
export default BreadcrumbVuexStore.default
